import { Component, OnInit, ViewChild, Input, OnDestroy, TemplateRef } from '@angular/core';
import { find } from 'lodash';
import { Logger } from '@app/core';
import { ReportsDataService } from './shared/reports.data.service';
import {
  Option,
  BaseControl,
  Reporte,
  ConfirmComponent,
  Static,
  ReporteTramite,
  CategoriaReporte
} from '@app/shared';
import { ReportsFormService } from './shared/reports.form.service';
import { Subject } from 'rxjs';

const log = new Logger('ReportsComponent');

@Component({
  selector: 'iw-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  providers: [ReportsDataService, ReportsFormService]
})
export class ReportsComponent implements OnInit, OnDestroy {

  // Contiene la categoria seleccionada
  @Input() category: CategoriaReporte;
  @Input() extensions: string[] = [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel.sheet.macroEnabled.12'
  ];
  // Texto de accion en el formulario
  actionForm = '';
  // Pregunta de la modal
  question = '';
  // Contiene el id del reporte seleccionado
  idReport: number = null;
  // Define si muestra el formulario de creación o edición de el reporte
  openForm = false;
  // Defini si la accion es editar o agregar
  edictAction = false;
  // Contiene el reporte seleccionado
  selectReport: Reporte;
  // Contiene el tipo del reporte seleccionado
  reportType: string;
  // Contiene los tramites asociados a el reporte
  sourceDataReport: ReporteTramite[] = [];
  // Contiene los tipos de reportes con formato para el drodown de los formularios dinámicos
  optionsTypeReports: Option[] = [];
  // Contiene los reportes
  reports: Reporte[] = [];
  // Contiene los reportes para mostrarlos en el selector
  reportsList: Reporte[] = [];
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // define si ha subido documento
  documentUpload = false;
  // Contiene el formulario de envio para guardar o modificar un reporte
  formData: FormData = new FormData();
  // Label de estenxiones para el accept del campo
  extensionsAccept = '';
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de cargar documento
  @ViewChild('fileUpload') fileUpload: TemplateRef<any>;


  constructor(
    private rds: ReportsDataService,
    private rfs: ReportsFormService,
  ) { }

  ngOnInit() {
    // Consulta los tipos de reportes
    this.rds.getTypesReports().subscribe(types => {
      if (types && types.length) {
        types.forEach(type => {
          this.optionsTypeReports.push({
            key: type.id,
            value: type.nombre
          });
        });
        log.debug(this.optionsTypeReports);
      }
    });
    this.loadingReports();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Define o controla la accion a realizar
   *
   * @param {('add' | 'update' | 'delete' | 'close')} [action='add']
   * @param {boolean} [setIdReport=true] se utiliza para la accion de close
   *                                     para reiniciar el id del reporte seleccionado
   * @memberof ReportsComponent
   */
  defineAction(action: 'add' | 'update' | 'delete' | 'close' = 'add', setIdReport: boolean = true) {
    const typeReport = find(this.optionsTypeReports, {value: 'Experto'});
    switch (action) {
      case 'update':
        this.actionForm = 'Modificar';
        this.openForm = true;
        this.controls = this.rfs.getForm(this.optionsTypeReports, this.selectReport, this.fileUpload,
          typeReport && typeReport.key > 0 ? typeReport.key : 0 );
        this.edictAction = true;
        break;
      case 'close':
        this.actionForm = '';
        this.openForm = false;
        this.edictAction = false;
        this.formData = new FormData();
        if (setIdReport) {
          this.idReport = null;
          this.selectReport = null;
        }
        this.question = '';
        break;
      case 'delete':
        this.actionForm = '';
        this.openForm = false;
        this.edictAction = false;
        this.question = '¿Realmente desea eliminar el reporte?';
        this.confirm.open();
        break;
      default:
        this.actionForm = 'Agregar';
        this.controls = this.rfs.getForm(this.optionsTypeReports, null, this.fileUpload,
          typeReport && typeReport.key > 0 ? typeReport.key : 0 );
        this.openForm = true;
        this.edictAction = false;
        this.idReport = null;
        this.selectReport = null;
        break;
    }
  }

  /**
   * Guarda o edita un reporte
   *
   * @param {*} data
   * @memberof ReportsComponent
   */
  sendedForm(data: any) {

    this.formData.append('nombre', data.txtNombre);
    this.formData.append('descripcion', data.txtDescripcion);
    this.formData.append('codigo', data.txtCodigo);
    this.formData.append('tipo_reporte', data.cboTipoReporte);
    this.formData.append('categoria', this.category.id.toString());
    this.formData.append('query', data.txtQuery);

    if (!this.edictAction) {
      this.rds.addReport(this.formData).subscribe(resp => {
        if (resp) {
          this.defineAction('close');
          this.loadingReports();
        }
      });
    } else {
      this.rds.updateReport(this.formData, this.idReport).subscribe(resp => {
        if (resp) {
          this.defineAction('close', false);
          this.loadingReports();
        }
      });
    }
  }

  /**
   * Controla las acciones realizadas en el modal de confirmaciones
   *
   * @param {boolean} resp
   * @memberof ReportsComponent
   */
  actionComfirm(resp: boolean) {
    if (resp) {
      this.deleteReport();
    }
  }

  /**
   * Controla el cambio del reporte seleccionado
   *
   * @param {*} data
   * @memberof ReportsComponent
   */
  selectReportChange(data: any) {
    this.idReport = null;
    this.selectReport = null;
    if (data) {
      const selRep = find(this.reports, {id: data.id});
      if (selRep) {
        this.selectReport = selRep;
        this.reportType = data.tipo_reporte.nombre;
      }
      this.rds.getReportsTramites(data.id).subscribe(dataT => {
        this.idReport = data.id;
        this.sourceDataReport = dataT;
      });
    }
  }

  /**
   * Carga los reportes en el selector principal
   *
   * @private
   * @memberof ReportsComponent
   */
  private loadingReports() {
    if (this.category && this.category.id) {
      this.rds.getReportsCategory(this.category.id).subscribe(category => {
        this.reports = Static.copyObjet(category.reportes);
        this.reportsList = Static.copyObjet(category.reportes);
        if (this.reportsList && this.reportsList.length) {
          this.reportsList.forEach(report => {
            report.nombre += ' - ' + report.codigo;
          });
        }
      });
    }
  }

  /**
   * Elimina el reporte seleccionado
   *
   * @private
   * @memberof ReportsComponent
   */
  private deleteReport() {
    this.rds.deleteReport(this.idReport).subscribe(resp => {
      if (resp) {
        this.loadingReports();
        this.idReport = null;
        this.selectReport = null;
      }
    });
  }


  /**
   * Controla el evento de cargar un documento de rótulo
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof StampComponent
   */
   private onAdded(data: any): any {
      this.formData.append('plantilla', data.file);
   }

  /**
   * Remueve el documento cargado
   *
   * @returns {*}
   * @memberof LoadInformationExcelComponent
   */
   onRemoved(): any {
    this.formData = new FormData();
    this.documentUpload = false;
  }

  /**
   * Agregar o remover un documento
   *
   * @param {*} data
   * @returns {*}
   * @memberof StampComponent
   */
   onAction(data: any): any {
    if (data.action === 1) {
      this.onAdded(data);
    } else if (data.action === 0) {
      this.onRemoved();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/reports.component.ts